import { getStorageSync } from './storage.js'
import { CHAT_BASE_URL } from '../common/js/constants.js'

/**
 * Deduplicate chat messages by order_id (fallback to time+sender+message).
 */
export function dedupeMessages(messages = []) {
	const seen = new Set()
	return messages.filter((msg) => {
		const key = msg.order_id != null && msg.order_id !== ''
			? String(msg.order_id)
			: `${msg.time}-${msg.sender}-${msg.message}`
		if (seen.has(key)) {
			return false
		}
		seen.add(key)
		return true
	})
}

/**
 * Wait until ownChatUrl is available (set by App.vue after config load).
 * Falls back to CHAT_BASE_URL after max attempts.
 */
export function waitForOwnChatUrl(maxAttempts = 40, intervalMs = 500) {
  return new Promise((resolve) => {
    let attempts = 0

    const check = () => {
      const url = getStorageSync('ownChatUrl')
      if (url) {
        resolve(url)
        return
      }

      attempts += 1
      if (attempts >= maxAttempts) {
        resolve(getStorageSync('ownChatUrl') || CHAT_BASE_URL)
        return
      }

      setTimeout(check, intervalMs)
    }

    check()
  })
}
